import React from 'react';

export const traduccionesDictionary = {
    VolverAlListado: {
        ES: 'Volver al listado',
        EN: '',
    },
    FechaMatriculacion: {
        ES: 'Fecha matriculación',
        EN: '',
    },
    Date: { ES: 'Fecha', EN: 'Date' },
    Seleccionado: {
        ES: 'Seleccionado',
        EN: 'Selected',
    },
    ES: {
        ES: 'Español',
        EN: 'Spanish',
        De: 'Adsaifhds fsdhaudfhm',
    },
    EN: {
        ES: 'Inglés',
        EN: 'English',
    },
    CifNombreEmpresa: {
        ES: 'Cif/Comprador',
        EN: 'Cif/Buyer',
        De: 'Adsaifhds fsdhaudfhm',
    },
    MarcaEstadistica: {
        ES: 'Marca estadistica',
        EN: 'Branch Estadistic',
        De: 'Adsaifhds fsdhaudfhm',
    },
    IncluirPuja: {
        ES: 'Incluir en Puja',
        EN: '',
        De: 'Adsaifhds fsdhaudfhm',
    },
    PrecioVehiculoTransporte: {
        ES: 'Precio del vehículo con transporte',
        EN: '',
    },
    VehiculoSinTransporte: {
        ES: 'Este vehículo no dispone de transporte',
        EN: '',
    },
    ConfirmarCompra: {
        ES: 'Confirmar compra',
        EN: '',
    },
    PriceVehicleNotAdjudication: {
        ES: 'Precio vehículo',
        EN: 'vehicle price',
    },
    AbrirCarrito: {
        ES: 'Abrir carrito',
        EN: '',
        De: '',
    },
    RentingVO: {
        ES: 'Renting VO',
        EN: '',
    },
    CompraDirecta: {
        ES: 'Compra directa',
        EN: 'Direct buy',
    },
    Lote: {
        ES: 'Lote',
        EN: 'Batch',
    },
    Puja: {
        ES: 'Puja',
        EN: 'Bid',
    },
    NumVehiculos: {
        ES: 'Nº vehículos',
        EN: '',
    },
    IrASubasta: {
        ES: 'Ir a subasta',
        EN: 'Go to auction',
    },
    DatosComprador: {
        ES: 'Datos de comprador',
        EN: 'Buyer data',
    },
    Comprador: {
        ES: 'Comprador',
        EN: 'Buyer',
    },
    PreferenciapPrederminada: {
        ES:
            'Deseo establecer estos datos como predeterminados para futuras compras o pujas',
        EN:
            'I want to set these details as defaults for future purchases or bids',
    },
    DatosEstadisticos: {
        ES: 'Datos Estadísticos',
        EN: 'Datas of estadistics',
    },
    DatosTransporte: {
        ES: 'Datos transporte',
        EN: 'transport Data',
    },
    CerrarSession: {
        ES: 'Cerrar sesión',
        EN: 'Close session',
    },
    MiPerfil: {
        ES: 'Mi Perfil',
        EN: 'Profile',
    },
    CambiarContraseña: {
        ES: 'Cambiar Contraseña',
        EN: 'Change password',
    },
    IncluirTransporte: {
        ES: 'Incluir Transporte',
        EN: 'Include Transport',
    },
    TituloTransporte: {
        ES: 'Transporte ',
        EN: 'Transport ',
    },
    TransportState: {
        ES: 'Estado',
        EN: 'Status',
    },
    LastLocation: {
        ES: 'Última ubicación',
        EN: 'Last Location',
    },
    VehicleRetired: {
        ES: 'Vehículo Retirado',
        EN: 'Vehicle Retired',
    },
    Direccionpreferencia: {
        ES: 'direcciones conse o otras ',
        EN: 'consesionarie or other direction ? ',
    },

    Si: {
        ES: 'Sí',
        EN: 'Yes',
    },
    No: {
        ES: 'No',
        EN: 'No',
    },
    FechaFin: {
        ES: 'Fecha fin',
        EN: '',
    },
    FechaInicio: {
        ES: 'Fecha inicio',
        EN: '',
    },
    EmpiezaEn: {
        ES: 'Empieza en',
        EN: '',
    },
    Consultando: {
        ES: 'Consultando...',
        EN: 'Consulting....',
    },
    Finalizada: {
        ES: 'Finalizada',
        EN: 'Finished',
    },
    FinalizaEn: {
        ES: 'Finaliza en',
    },
    TipoSubasta: {
        ES: 'Tipo subasta',
    },
    VehiculosPagados: {
        ES: 'Vehículos pagados',
        EN: '',
    },
    VehiculosPdteCobro: {
        ES: 'Vehículos pdte.cobro',
        EN: '',
    },
    MaximaPuja: {
        ES: 'Máxima puja',
        EN: '',
    },
    PujasSuperadas: {
        ES: 'Pujas Superadas',
        EN: '',
    },
    LotesEnNegociacion: {
        ES: 'Lotes en negociación',
        EN: '',
    },
    Subastas: {
        ES: 'Subastas',
        EN: 'Auctions',
    },
    VencimientosRenting: {
        ES: 'Vencimientos Renting',
        EN: 'Renting Maturities',
    },
    Huerto: {
        ES: 'Vencimientos',
        EN: 'Vencimientos',
    },
    SubastasActivas: {
        ES: 'Subastas Activas',
        EN: 'Active Auctions',
    },
    SinSubastasActivas: {
        ES: 'Actualmente no hay subastas activas',
        EN: 'Currently no active auctions',
    },
    ProximasSubastas: {
        ES: 'Próximas Subastas',
        EN: 'Upcoming Auctions',
    },
    SinProximasActivas: {
        ES: 'Actualmente no hay previstas próximas subastas',
        EN: 'There are currently no upcoming auctions planned',
    },
    Login: {
        ES: 'Entrar',
        EN: 'Login',
    },
    Register: {
        ES: 'Registrarse',
        EN: 'Register',
    },
    PlaceHolderUser: {
        ES: 'Usuario',
        EN: 'User',
    },
    PlaceHolderPassword: {
        ES: 'Contraseña',
        EN: 'Password',
    },
    CaptchaError: {
        ES: 'Datos incorrectos',
        EN: 'Invalid Data',
    },
    ForgotPassword: {
        ES: '¿Olvidada?',
        EN: 'Forgot?',
    },
    Solicitar: {
        ES: 'Solicitar',
        EN: 'Request',
    },
    Accept: {
        ES: 'Aceptar',
        EN: 'Accept',
    },
    Cancelar: {
        ES: 'Cancelar',
        EN: 'Cancel',
    },
    ResetPasswordProfile: {
        ES: 'Restablecer contraseña',
    },
    ResetPassword: {
        ES: 'Restablecer contraseña olvidada o cuenta bloqueada',
    },
    TermsAccept: {
        ES: 'He leído y acepto el',
        EN: 'I have read and accept this',
    },
    ContactUs: {
        ES: 'Si tienes alguna duda, contáctanos.',
        EN: 'If you have any questions, contact us.',
    },
    LegalAdvice: {
        ES: 'Aviso Legal',
        EN: 'Legal Advice',
    },
    Detalle: {
        ES: 'Ver detalle',
    },
    Vehicle: {
        ES: 'Vehículo',
        EN: 'Vehicle',
    },
    Vehicles: {
        ES: 'Vehículos',
        EN: 'Vehicles',
    },
    Total: {
        ES: 'Total',
        EN: 'Total',
    },
    VerVehPujados: {
        ES: 'Ver vehiculos pujados',
    },
    ContinuarPuja: {
        ES: 'Seguir pujando',
    },
    BtnGuardar: {
        ES: 'Guardar',
        EN: 'Save',
    },
    BtnGuardarPreferencias: {
        ES: 'Guardar preferencias',
        EN: 'Save preferences',
    },
    BtnDownloadPDFProforma: {
        ES: 'Bajar PDF Proforma',
        EN: 'Download PDF payment data',
    },
    BtnActualizarPrecioSolicitudTransporte: {
        ES: 'Guardar / Regenerar carta de adjudicación',
        EN: 'Save / Regenerate Award Letter',
    },
    MessageProfilePreferences: {
        ES:
            '*Se guardarán tus preferencias para futuras pujas y compras. Siempre podrás modificarlas desde este apartado.',
        EN:
            'Your preferences will be saved for future bids and purchases. You can always modify them from this section.',
    },
    BtnActualizar: {
        ES: 'Actualizar',
        EN: 'Update',
    },
    Account: {
        ES: 'Cuenta',
        EN: 'Account',
    },
    Profile: {
        ES: 'Perfil',
        EN: 'Profile',
    },
    AccountText: {
        ES: 'Valida que tenemos los datos correctos',
        EN: 'Validate that we have the correct data',
    },
    DocumentType: {
        ES: 'NIF/NIE',
        EN: 'NIF/NIE',
    },
    Name: {
        ES: 'Nombre',
        EN: 'Name',
    },
    Surname: {
        ES: 'Primer Apellido',
        EN: 'Surname',
    },
    Surname2: {
        ES: 'Segundo Apellido',
    },
    Email: {
        ES: 'Email',
        EN: 'Email',
    },
    Phone: {
        ES: 'Teléfono',
        EN: 'Phone',
    },
    Preferences: {
        ES: 'Preferencias',
        EN: 'Preferences',
    },
    BuyedVehicles: {
        ES: 'Vehículos comprados',
        EN: 'Buyed vehicles',
    },
    MyVehicles: {
        ES: 'Mis vehículos',
        EN: 'My vehicles',
    },
    Password: {
        ES: 'Contraseña',
        EN: 'Password',
    },
    PersonalData: {
        ES: 'Datos personales',
        EN: 'Personal data',
    },
    PasswordTitle: {
        ES: 'Cambio de contraseña',
        EN: '',
    },
    PasswordSubTitle: {
        ES: 'Introduce la contraseña actual para poder modificarla',
        EN: '',
    },
    PasswordActual: {
        ES: 'Contraseña actual',
        EN: '',
    },
    PasswordNew: {
        ES: 'Nueva contraseña',
        EN: '',
    },
    PasswordNewRepeat: {
        ES: 'Repetir contraseña',
        EN: 'Repeat password',
    },
    registerFormUploadTitle: {
        ES: 'Subir el IAE',
        EN: '',
    },
    AddressLabel: {
        ES: 'Dirección',
        EN: '',
    },
    CityLabel: {
        ES: 'Provincia',
        EN: '',
    },
    Optional: {
        ES: 'Opcional',
        EN: 'Optional',
    },
    PoblationLabel: {
        ES: 'Población',
        EN: 'Poblation ',
    },
    PostalCodeLabel: {
        ES: 'Código Postal',
        EN: '',
    },
    Installation: {
        ES: 'Concesionario',
        EN: 'Concesionarie',
    },
    InstallationExposition: {
        ES: 'Concesionario estadística',
        EN: 'Concesionarie estadistics ',
    },
    OptionsTypeVia: {
        ES: 'Tipo vía',
        EN: 'Type way',
    },

    OptionsVia: {
        ES: 'Vía',
        EN: 'Way',
    },

    DestinoPreferenciadato: {
        ES: 'Destino',
        EN: 'Destiny ',
    },
    PlaceHolderDestiny: {
        ES: 'p.ej : Mi mecánico asociado',
        EN: 'f.ex: Mi mechanic asociated',
    },
    NumberWay: {
        ES: 'Nª',
        EN: 'Nª',
    },
    BranchEstadistics: {
        ES: 'Marca Exposición',
        EN: 'Branch exposition',
    },
    registerFormUploadDescription: {
        ES: 'Haz click aquí para elegirlo',
        EN: 'Click here to choose it',
    },
    registerFormUploadButtonText: {
        ES: 'Subir archivo 🚀',
        EN: 'Upload file 🚀',
    },
    PriceASC: {
        ES: 'Precio Salida Ascendente',
        EN: 'Price (Ascending)',
    },
    PriceDESC: {
        ES: 'Precio Salida Descendente',
        EN: 'Price (Descending)',
    },
    KmsASC: {
        ES: 'Km Ascendente',
        EN: 'Km (Ascending)',
    },
    KmsDESC: {
        ES: 'Km Descendente',
        EN: 'Km (Descending)',
    },
    RegistrationDateDESC: {
        ES: 'Más nuevos',
        EN: 'More news',
    },
    RegistrationDateASC: {
        ES: 'Más antiguos',
        EN: 'More Older',
    },
    Favourits: {
        ES: 'Favoritos',
        EN: 'Favourits',
    },
    Bids: {
        ES: 'Pujados',
        EN: 'Bids',
    },
    Brands: {
        ES: 'Marcas',
        EN: 'Brands',
    },
    Kms: {
        ES: 'Kilometraje',
        EN: 'Mileage',
    },
    Agrupations: {
        ES: 'Agrupaciones',
        EN: 'Agrupations',
    },
    Transmission: {
        ES: 'Transmisión',
        EN: 'Transmission',
    },
    Energies: {
        ES: 'Energías',
        EN: 'Energies',
    },
    Zones: {
        ES: 'Zonas',
        EN: 'Zones',
    },
    Power: {
        ES: 'Potencia (CV)',
        EN: 'Power (CV)',
    },
    PriceMax: {
        ES: 'Precio',
        EN: 'Price',
    },
    Price: {
        ES: 'Precio (€)',
        EN: 'Price (€)',
    },
    GASOLINA: {
        ES: 'Gasolina',
        EN: 'Petrol',
    },
    DIESEL: {
        ES: 'Diésel',
        EN: 'Diesel',
    },
    ELECTRICO: {
        ES: 'Eléctrico',
        EN: 'Electric',
    },
    Peninsula: {
        ES: 'Península',
        EN: 'Peninsula',
    },
    Plate: {
        ES: 'Matrícula',
        EN: 'Plate',
    },
    MatriculationYear: {
        ES: 'Año matriculación',
        EN: 'Year of matriculation',
    },
    Desde: {
        ES: 'Desde',
        EN: 'From',
    },
    Hasta: {
        ES: 'Hasta',
        EN: 'To',
    },
    Ano: {
        ES: 'Año',
        EN: 'Year',
    },
    AnoDeCompra: {
        ES: 'Año de compra',
        EN: 'Year of purchase',
    },
    Mes: {
        ES: 'Mes',
        EN: 'Month',
    },
    MesDeCompra: {
        ES: 'Mes de compra',
        EN: 'Month of purchase',
    },
    Pending: {
        ES: 'Pendiente',
        EN: 'Pending',
    },
    Outstanding: {
        ES: 'Pendiente de pago',
        EN: 'Outstanding',
    },
    Payed: {
        ES: 'Pagado',
        EN: 'Payed',
    },
    BuyDate: {
        ES: 'Fecha compra',
        EN: 'Buy date',
    },
    PayDate: {
        ES: 'Fecha pago',
        EN: 'Pay date',
    },
    PayState: {
        ES: 'Estado pago',
        EN: 'Pay state',
    },
    Origin: {
        ES: 'Origen',
        EN: 'Origin',
    },
    Destination: {
        ES: 'Destino',
        EN: 'Destination',
    },
    EBrand: {
        ES: 'Marca E.',
        EN: 'E. Brand',
    },
    EConcessionaire: {
        ES: 'Concesionario E.',
        EN: 'E. Concessionaire',
    },
    ExhibitionBrand: {
        ES: 'Marca exposición',
        EN: 'Exhibition brand',
    },
    ExhibitionConcessionaire: {
        ES: 'Concesionario exposición',
        EN: 'Exhibition concessionaire',
    },
    ViewAll: {
        ES: 'Ver Todo',
        EN: 'View all',
    },
    ViewLess: {
        ES: 'Ver menos',
        EN: 'View less',
    },
    DeleteAll: {
        ES: 'Eliminar todo',
        EN: 'Delete all',
    },
    Delete: {
        ES: 'Eliminar',
        EN: 'Delete',
    },
    Transport: {
        ES: 'Transporte',
        EN: 'Transport',
    },
    VehiclePrice: {
        ES: 'Precio vehículo',
        EN: 'Vehicle price',
    },
    Show: {
        ES: 'Mostrar',
        EN: 'Show',
    },
    ApplyFilters: {
        ES: 'Aplicar filtros',
        EN: 'Apply filters',
    },
    SavePreferences: {
        ES: 'Guardar preferencias',
        EN: 'Save preferences',
    },
    InitLegalAlertLabel: {
        ES: 'Por favor, ',
        EN: 'Please',
    },
    LegalAlertLabel: {
        ES: 'lee el aviso legal',
        EN: 'read legal alert ',
    },
    YesSeeLegalAlert: {
        ES: 'He leído los datos del aviso legal y acepto las condiciones',
        EN: 'I read the datas of legal alert an acept the conditions ',
    },
    NoSeeLegalAlert: {
        ES: 'No he leído o no acepto las condiciones',
        EN: 'I not read or no acept the conditions',
    },
    WithoutVehicles_title: {
        ES: 'Lo sentimos, no hemos encontrado ningún vehículo',
        EN: 'Sorry, we have not found any vehicle',
    },
    WithoutVehicles_body: {
        ES:
            'En una futura fase podrás crear una alerta con los filtros que hayas elegido y recibir un correo con los vehículos añadidos',
        EN:
            'In a future phase you can create an alert with the filters you have chosen and you will receive an email with the added vehicles',
    },
    WithoutVehicles_body2: {
        ES:
            'Elige otra combinación de filtros para poder ver tus vehículos disponibles',
        EN:
            'Choose another combination of filters to be able to buy your vehicles correctly',
    },
    WithoutVehiclesPurchased_title: {
        ES: 'Todavía no tienes ningún vehículo comprado',
        EN: "You still don't have no purchased vehicle",
    },
    WithoutVehiclesPurchased_body: {
        ES:
            'Puedes ir a la sección de subastas para poder empezar a comprar vehículos',
        EN: 'You can go to the auction section to start buying vehicles',
    },
    PurchaseMade_title: {
        ES: 'Compra realizada correctamente',
        EN: 'Your reservation has been made successfully',
    },
    ReserveMade_title: {
        ES: 'Tu reserva se ha realizado con éxito',
        EN: 'Your reservation has been made successfully',
    },
    PurchaseMade_body: {
        ES:
            'Encontrarás tu nueva adquisición en el listado de vehículos comprados. Desde esta página puedes ver en qué estado se encuentran tus vehículos',
        EN:
            'You will find your new acquisition in the list of vehicles purchased. From this page you can see what state your vehicles are in',
    },
    Manual: {
        ES: 'Manual',
        EN: 'Manual',
    },
    Automatic: {
        ES: 'Automático',
        EN: 'Automatic',
    },
    YourMaximumBid: {
        ES: 'Tu puja máxima',
        EN: 'Your maximum bid',
    },
    MaximumBid: {
        ES: 'Puja máxima',
        EN: 'Maximum bid',
    },
    YoutMaximumBidHere: {
        ES: 'Indica tu puja máxima',
        EN: 'Indicates your maximum bid',
    },
    CurrentBid: {
        ES: 'Puja actual',
        EN: 'Current bid',
    },
    InitialBid: {
        ES: 'Puja salida',
        EN: 'Initial bid',
    },
    Buy: {
        ES: 'Comprar',
        EN: 'Buy',
    },
    BuyNow: {
        ES: 'Comprar ahora',
        EN: 'Buy now',
    },
    BidUp: {
        ES: 'Pujar',
        EN: 'Bid up',
    },
    DirectPurchase: {
        ES: 'Compra directa',
        EN: 'Direct purchase',
    },
    Filters: {
        ES: 'Filtros',
        EN: 'Filters',
    },
    AdvancedFilters: {
        ES: 'Filtros avanzados',
        EN: 'Advanced filters',
    },
    ResetFilters: {
        ES: 'Restablecer filtros',
        EN: 'Reset filters',
    },
    EditData: {
        ES: 'Editar datos',
        EN: 'Edit data',
    },
    EditDataAndRegeneratedEmail: {
        ES: 'Editar / Regenerar carta de adjudicación',
        EN: 'Edit / Regenerate Award Letter',
    },
    OrderBy: {
        ES: 'Ordenar por',
        EN: 'Order by',
    },
    Previous: {
        ES: 'Anterior',
        EN: 'Previous',
    },
    Next: {
        ES: 'Siguiente',
        EN: 'Next',
    },
    Fuel: {
        ES: 'Combustible',
        EN: 'Fuel',
    },
    Displacement: {
        ES: 'Cilindrada',
        EN: 'Displacement',
    },
    NumberDoors: {
        ES: 'Nº puertas',
        EN: 'Num. doors',
    },
    TaxHorsePower: {
        ES: 'Caballos fiscales',
        EN: 'Tax HorsePower',
    },
    ExternalColor: {
        ES: 'Color exterior',
        EN: 'External color',
    },
    InternalColor: {
        ES: 'Color interior',
        EN: 'Internal color',
    },
    Gearbox: {
        ES: 'Caja de cambios',
        EN: 'Gearbox',
    },
    CO2Emissions: {
        ES: 'Emisiones de CO2',
        EN: 'CO2 Emissions',
    },
    VehicleLocation: {
        ES: 'Ubicación Vehiculo',
        EN: 'Vehicle location',
    },
    Location: {
        ES: 'Ubicación',
        EN: 'Location',
    },
    WithoutLocation: {
        ES: 'Sin localización informada',
        EN: 'Without location',
    },
    Day: {
        ES: 'Día',
        EN: 'Day',
    },
    Days: {
        ES: 'Días',
        EN: 'Days',
    },
    AConesionario: {
        ES: 'A concesionario',
        EN: 'To concesionarie',
    },
    Otras: {
        ES: 'Otras',
        EN: 'Others',
    },
    NotFoundAnyVehicle: {
        ES: 'No hemos encontrado ningún vehículo con estos parámetros',
        EN: 'We have not found any vehicle with these parameters',
    },
    WeFound: {
        ES: 'Hemos encontrado',
        EN: 'We have not found any vehicle with these parameters',
    },
    VehicleForYou: {
        ES: 'vehículo para ti',
        EN: 'vehicle for you',
    },
    VehiclesForYou: {
        ES: 'vehículos para ti',
        EN: 'vehicles for you',
    },
    VehicleFound: {
        ES: 'vehículo encontrado',
        EN: 'vehicle found',
    },
    VehiclesFound: {
        ES: 'vehículos encontrados',
        EN: 'vehicles found',
    },
    EditPreferences: {
        ES: 'Editar preferencias',
        EN: 'Edit preferences',
    },
    ContinueWithoutPreferences: {
        ES: 'Posponer',
        EN: 'Postpone',
    },
    ModalFirstBidPreferences_Title: {
        ES: '¡Te damos la bienvenida!',
        EN: '¡Welcome!',
    },
    ModalFirstBidPreferences_Body_1: {
        ES: 'Para poder pujar, debes definir un comprador por defecto en tus',
        EN: 'In order to bid, you must define a default buyer in your',
    },
    ModalFirstBidPreferences_Body_2: {
        ES: 'Preferencias.',
        EN: 'Preferences.',
    },
    ModalFirstBidPreferences_Body_3: {
        ES: 'Podrás modificar estos datos siempre que quieras.',
        EN: 'You can modify this data whenever you want.',
    },
    GoToMyVehicles: {
        ES: 'Ir a mis vehículos',
        EN: 'Go to my vehicles',
    },
    States: {
        ES: 'Estados',
        EN: 'States',
    },
    Buyers: {
        ES: 'Compradores',
        EN: 'Buyers',
    },
    ModalSameBid_Title: {
        ES: '¡Vaya! Puja máxima igualada',
        EN: '¡Oops! Maximum matched bid',
    },
    ModalSameBid_Body: {
        ES:
            'Parece que alguien se ha adelantado con la misma cantidad de Puja Máxima con ',
        EN:
            'It seems that someone has gone ahead with the same amount of Maximum Bid with ',
    },
    ModalSameBid_Body_2: {
        ES: 'Debes superar esta puja con una diferencia de al menos ',
        EN: 'You must overcome this bid with a difference of at least ',
    },
    ModalSameBid_Error: {
        ES:
            'La puja actual ha sido superada por otra persona. ¡Vuelve a pujar con una cantidad más elevada para hacerte con el vehículo!',
        EN:
            'The current bid has been exceeded by someone else. Bid again with a higher amount to get the vehicle!',
    },
    ModalDirectPurchase_Title_equal: {
        ES: 'Has igualado el precio de Compra Directa',
        EN: '',
    },
    ModalDirectPurchase_Title_surpass: {
        ES: 'Has superado el precio de Compra Directa',
        EN: '',
    },
    ModalDirectPurchase_Body: {
        ES: 'El precio de',
        EN: 'Your bid of ',
    },
    ModalDirectPurchase_Body_2: {
        ES: 'Compra Directa del vehículo es de',
        EN: '',
    },
    ModalDirectPurchase_Body_3: {
        ES:
            'Si lo quieres por este precio cómpralo antes de que se te adelanten.',
        EN: '',
    },
    EquipmentsSeriesTitle: {
        ES: 'Equipamiento de serie',
        EN: 'Series Equipments ',
    },
    EquipmentsExtraTitle: {
        ES: 'Equipamiento Opcional',
        EN: 'Extras Equipments ',
    },
    MessageEquipmentsSeries: {
        ES: 'No hay equipamiento de serie ',
        EN: "There Isn't Series Equipments",
    },
    MessageEquipmentsExtras: {
        ES: 'No hay equipamiento opcional',
        EN: "There Isn't Extra Equipment",
    },
    DataNoAvailable: {
        ES: 'Datos no disponibles',
        EN: 'Data no available',
    },
    DataFetchError: {
        ES: 'Error al intentar recuperar los datos',
        EN: 'An error occurred while trying to retrieve the data',
    },
    WinningBid: {
        ES: 'Tienes la mejor puja',
        EN: 'Best bid',
    },
    BidExceeded: {
        ES: 'Puja máxima superada',
        EN: 'Bid Exceeded',
    },
    Return: {
        ES: 'Volver',
        EN: 'Return',
    },
    Back: {
        ES: 'Atrás',
        EN: 'Volver',
    },
    PurchasedVehicle: {
        ES: 'Vehículo comprado',
        EN: 'Purchased vehicle',
    },
    Sold: {
        ES: 'Vendido',
        EN: 'Sold',
    },
    Reserved: {
        ES: 'Reservado',
        EN: 'Reserved',
    },
    VehicleDetails: {
        ES: 'Detalles del vehículo',
        EN: 'Vehicle details',
    },
    Observations: {
        ES: 'Observaciones',
        EN: 'Observations',
    },
    VehiclesPurchaseOption: {
        ES: 'Vehículos en opción a compra',
        EN: 'Vehicles in option to purchase',
    },
    PurchaseOption: {
        ES: 'Opción a compra',
        EN: 'Option to purchase',
    },
    ActiveVehicles: {
        ES: 'Vehículos activos',
        EN: 'ActiveVehicles',
    },
    ExpirationManagement: {
        ES: 'Gestión vencimientos',
        EN: 'Expiration management',
    },
    MyShopping: {
        ES: 'Mis compras',
        EN: 'My shopping',
    },
    MyBids: {
        ES: 'Mis pujas',
        EN: 'My bids',
    },
    EditProfile: {
        ES: 'Editar perfil',
        EN: 'Edit profile',
    },
    Expertsreports: {
        ES: 'Peritajes',
        EN: "Expert's reports",
    },
    Expertsreport: {
        ES: 'Peritaje',
        EN: "Expert's reports",
    },
    ExportpdfTitleExpertise: {
        ES: 'Exportar a pdf peritaje',
        EN: 'Export to pdf',
    },
    ModalUpdatePriceVehicle_Title: {
        ES: 'Editar datos del vehículo',
        EN: '',
    },
    Aconcesionario: {
        ES: 'Concesionario',
        EN: '',
    },
    LegalNote: {
        ES: 'Nota legal',
        EN: 'Legal note',
    },
    PrivacyPolicy: {
        ES: 'Política de privacidad',
        EN: 'Privacy policy',
    },
    CookiesPolicy: {
        ES: 'Política de cookies',
        EN: 'Cookies policy',
    },
    ThirdPartyLicenseNotice: {
        ES: 'Aviso de licencia de terceros',
        EN: 'Third party license notice',
    },
    Faqs: {
        ES: 'Preguntas frecuentes',
        EN: 'Frequent questions',
    },
    dealerReceptor: {
        ES: 'Concesionario receptor',
        EN: 'Receiving dealer',
    },
    PurchaseOptionReceiverDealer: {
        ES: 'Opción compra Concesionario Receptor',
        EN: 'Purchase option Receiver Dealer',
    },
    ComercialProducts: {
        ES: 'Productos comerciales',
        EN: 'Comercial products',
    },
    ReturnDealers: {
        ES: 'Concesionarios devolución',
        EN: 'Return dealers',
    },
    ReturnDealer: {
        ES: 'Concesionario devolución',
        EN: 'Return dealer',
    },
    GoToAuctions: {
        ES: 'Ir a Subastas',
        EN: 'Go to auctions',
    },
    WithoutVehiclesReturnDealers_title: {
        ES: 'No hay ningún vehículo disponible',
        EN: 'No vehicle available',
    },
    WithoutVehiclesReturnDealers_body: {
        ES: '',
        EN: '',
    },
    VIN: {
        ES: 'Bastidor',
        EN: 'VIN',
    },
    TakeADecision: {
        ES: 'Tomar decisión',
        EN: 'Take a decision',
    },
    FinancialOperation: {
        ES: 'Operación financiera',
        EN: 'Financial operation',
    },
    PurchaseOptionStartEnd: {
        ES: 'Opción a compra inicio - fin',
        EN: 'Option to buy start - end',
    },
    AmountOfTheVehicle: {
        ES: 'Importe del vehículo',
        EN: 'Amount of the vehicle',
    },
    Irrevocable: {
        ES: 'Irrevocable',
        EN: 'Irrevocable',
    },
    PenaltyForDismissal: {
        ES: 'Penalización por desestimación',
        EN: 'Penalty for dismissal',
    },
    DismissalWithourReport: {
        ES: 'Vehículo no peritado, no es posible rechazar la recompra.',
        EN:
            'Vehicle not appraised, it is not possible to reject the repurchase.',
    },
    DismissalWithourReport_Full: {
        ES:
            'Para este vehículo se ha tomado la decisión por parte del concesionario de no peritar, por lo que no es posible rechazar la recompra. Si desea continuar con su decisión de rechazar la recompra, póngase en contacto con terminaciones@vwfs.com.',
        EN:
            'For this vehicle, the decision has been made by the dealer not to appraise, so it is not possible to reject the repurchase. If you wish to proceed with your decision to reject the buyback, please contact terminations@vwfs.com.',
    },
    CurrentWarranty: {
        ES: 'Garantía vigente',
        EN: 'Current Warranty',
    },
    Penalty: {
        ES: 'Penalización',
        EN: 'Penalty',
    },
    PurchaseOptionDate: {
        ES: 'Fecha de opción de compra',
        EN: 'Purchase option date',
    },
    ValidWarrantyExtension: {
        ES: 'Extensión de garantía vigente',
        EN: 'Valid warranty extension',
    },
    WithValidWarrantyExtension: {
        ES: 'Con extensión de garantía vigente',
        EN: 'With valid warranty extension',
    },
    Contact: {
        ES: 'Contacto',
        EN: 'Contact',
    },
    AuctionsContact: {
        ES: 'Contacto de Subastas',
        EN: 'Auctions Contact',
    },
    ExpirationContact: {
        ES: 'Contacto de Vencimientos',
        EN: 'Expiration contact',
    },
    Tarificate: {
        ES: 'Tarificar',
        EN: 'Tarificate',
    },
    Quote: {
        ES: 'Cotizar',
        EN: 'Quote',
    },
    RVO: {
        ES: 'Cuota Mensual',
        EN: 'Monthly Fee',
    },
    RVO_legal: {
        ES:
            '*Cuota calculada con {mesesCuota} meses, {KmCuota} km y {entradaCuota} de entrada', //sin entrada
        EN:
            'Fee calculated with {mesesCuota} months, {KmCuota} Km and {entradaCuota} entry', //no entry
    },
    IncentiveAvailable: {
        ES: 'Incentivo disponible',
        EN: 'Incentive available',
    },
    ImporteIncentivoRecompra: {
        ES: 'Imp. Incentivo',
        EN: 'Repurchase Incentive Amount',
    },
    ModalTakeDecision_incentive_prefix: {
        ES: 'VWR te abonará ',
        EN: 'VWR will pay you ',
    },
    ModalTakeDecision_incentive_suffix: {
        ES: ' si optas por ADQUIRIR (sin venta a VWR)',
        EN: ' if you choose to PURCHASE (without sale to VWR)',
    },
    TermFinaliced: {
        ES: 'Plazo finalizado',
        EN: 'Term finaliced',
    },
    ModalTakeDecision_title: {
        ES: '¿Qué deseas hacer con este vehículo?',
        EN: 'What do you want to do with this vehicle?',
    },
    Reject: {
        ES: 'Desestimar',
        EN: 'Reject',
    },
    Negotiate: {
        ES: 'Negociar',
        EN: 'Negotiate',
    },
    ModalRejectVehicle_body_1: {
        ES:
            'La desestimación de compra de este vehículo generará automáticamente una',
        EN:
            'The purchase dismissal of this vehicle will automatically create a',
    },
    ModalRejectVehicle_body_2: {
        ES: 'orden de transporte a nuestra CAMPA.',
        EN: 'transport order to our CAMPA.',
    },
    ModalRejectVehicle_body_penalty_1: {
        ES: 'La desestimación de compra de este vehículo conlleva una',
        EN: 'The purchase dismissal of this vehicle reveals a',
    },
    ModalRejectVehicle_body_penalty_2: {
        ES: 'penalización de',
        EN: 'penalty of',
    },
    ModalRejectVehicle_title_rejected: {
        ES: 'La compra del vehículo ha sido desestimada',
        EN: 'The purchase of the vehicle has been rejected',
    },
    ModalRejectVehicle_body_rejected: {
        ES: 'Puedes volver al listado de vehículos.',
        EN: 'You can return to the vehicle list.',
    },
    DismissPurchase: {
        ES: 'Desestimar compra',
        EN: 'Dismiss Purchase',
    },
    StartNegotiation: {
        ES: 'Iniciar negociación',
        EN: 'Start negotiation',
    },
    Close: {
        ES: 'Cerrar',
        EN: 'Close',
    },
    ReasonType: {
        ES: 'Tipo motivo',
        EN: 'Reason type',
    },
    Reason: {
        ES: 'Motivo',
        EN: 'Reason',
    },
    Comment: {
        ES: 'Comentario',
        EN: 'Comment',
    },
    ModalNegotiateVehicle_title: {
        ES: '¿Qué importe estás dispuesto a pagar por este vehículo?',
        EN: 'What amount are you willing to pay for this vehicle?',
    },
    ModalNegotiateVehicle_subtitle: {
        ES: 'Por favor, dinos el motivo de tu contraoferta.',
        EN: 'Please tell us the reason for your counter offer.',
    },
    ModalNegotiateVehicle_title_acepted: {
        ES: 'Hemos recibido tu contraoferta',
        EN: 'We have received your counter offer',
    },
    ModalNegotiateVehicle_body_acepted: {
        ES:
            'Estamos valorandola y pronto recibirás un correo con nuestra respuesta.',
        EN:
            'We are evaluating your counter offer. You will soon receive an email with our response.',
    },
    Import: {
        ES: 'Importe',
        EN: 'Import',
    },
    RequestErrorMessage: {
        ES:
            'Se ha producido un error al realizar la operación. Por favor, vuelve a intentarlo de nuevo. Si el error persiste contacta con nosotros.',
        EN:
            'An error occurred while performing the operation. Please try again. If the error persists, contact us.',
    },
    TermExpired: {
        ES: 'Plazo expirado',
        EN: 'Term expired',
    },
    ExpirationMatrix: {
        ES: 'Matriz de vencimientos',
        EN: 'Expiration Matrix',
    },
    BuyVehicle: {
        ES: 'Comprar vehículo',
        EN: 'Buy vehicle',
    },
    MessageOops_title: {
        ES: '¡Vaya! Se ha producido un error',
        EN: 'Opps! An error has occurred',
    },
    MessageOops_buyed_error_title: {
        ES: '¡Vaya! Se ha producido un error',
        EN: 'Opps! An error has occurred',
    },
    MessageOops_body: {
        ES:
            'Ha habido un error al intentar realizar la compra de este vehículo inténtalo de nuevo o ponte en contacto con nosotros',
        EN:
            'An error has occured when trying to purchase this vehicle, please try again or contact us',
    },
    MessageOops_buyed_title: {
        ES: '¡Vaya! Alguien ha comprado este vehículo',
        EN: 'Opps! Someone has gone ahead with the purchase',
    },
    MessageOops_buyed_body: {
        ES:
            'Otra persona se te ha adelantado y ha comprado este vehículo. Vuelve al listado para elegir otro disponible.',
        EN:
            'Someone has gone ahead and bought this vehicle. Be faster next time.',
    },
    Oops: {
        ES: '¡Vaya!',
        EN: 'Opps!',
    },
    ModalExposureBrand_body: {
        ES:
            'No tienes marcas de exposición disponibles. Por favor, ponte en contacto con nosotros a través de Profit.center@vwfs.com',
        EN:
            'You have no exposure marks available. Please contact us at Profit.center@vwfs.com',
    },
    RentingVOSimulationFinder: {
        ES: 'Buscador de simulaciones Renting VO',
        EN: 'Renting VO simulations finder',
    },
    EnvioMailSatisfactorioCambioContrasenya: {
        ES: 'Se le ha enviado un email para restablecer contraseña',
        EN: '',
    },
    ErrorEnvioMailCambioContrasenya: {
        ES: 'Error, no se ha podido realizar el restablecimiento de contraseña',
        EN: '',
    },
    Download: {
        ES: 'Descargar',
        EN: 'Download',
    },
    Tooltip_max_bid_title: {
        ES: '¿Cómo funciona la puja máxima?',
        EN: 'How does the maximum bid work?',
    },
    Tooltip_max_bid_body: {
        ES:
            'Solo tienes que introducir el precio máximo que estás dispuesto a pagar por el vehículo y nosotros nos encargamos del resto. Pujaremos automáticamente por ti lo justo para mantenerte a la cabeza de la subasta, pero sin sobrepasar ese límite. Si alguien te sobrepuja, te informaremos para que puedas decidir si deseas aumentar tu límite máximo.',
        EN:
            'Just enter the maximum price you are willing to pay for the vehicle and we will take care of the rest. We will automatically bid for you just enough to keep you ahead of the auction, but without exceeding that limit. If someone outbid you, we will inform you so you can decide if you want to increase your maximum limit.',
    },
    Extended: {
        ES: 'Prorrogado',
        EN: 'Extended',
    },
    ExtensionNumber: {
        ES: 'ª Prórroga',
        EN: ' Extension',
    },
    Extension: {
        ES: 'Prórroga',
        EN: 'Extension',
    },
    LastExtension: {
        ES: 'Última Prórroga',
        EN: 'Last Extension',
    },
    CarBatchUnavailable: {
        ES: 'Este coche ya no está disponible para añadir al Lote',
        EN: 'Car is no longer available to be added to the Batch',
    },
    SelectedPlural: {
        ES: 'Seleccionados',
        EN: 'Selected',
    },
    TrolleyFormNameLabel: {
        ES: 'Nombre de Lote',
        EN: "Batch's name",
    },
    TrolleyFormNamePlaceholder: {
        ES: 'Introduce un nombre',
        EN: 'Type a name',
    },
    TrolleyFormNameRequired: {
        ES: 'Es necesario un nombre para el lote',
        EN: "Batch's name is required",
    },
    TrolleyLimitAmountError: {
        ES: 'Debes seleccionar 3 o más vehículos',
        EN: 'You need to select 3 or more vehicles',
    },
    CreateBatch: {
        ES: 'Crear lote',
        EN: 'Create batch',
    },
    MyBatches: {
        ES: 'Gestión de lotes',
        EN: 'Batch Management',
    },
    MyBatchesAmount: {
        ES: amount =>
            `Tienes ${amount} lote${amount === 1 ? '' : 's'} en tu historial`,
        EN: amount =>
            `You have ${amount} batch${amount === 1 ? '' : 'es'
            } in your history`,
    },
    MyBatchesFormNameLabel: {
        ES: '',
        EN: '',
    },
    MyBatchesFormStatusLabel: {
        ES: 'Estado del lote',
        EN: 'Batch status',
    },
    Status: {
        ES: 'Estado',
        EN: 'Status',
    },
    Auction: {
        ES: 'Subasta',
        EN: 'Auction',
    },
    CreationDate: {
        ES: 'Fecha creación',
        EN: 'Creation date',
    },
    bought: {
        ES: 'Comprado',
        EN: 'Bought',
    },
    cancelled: {
        ES: 'Anulado',
        EN: 'Cancelled',
    },
    AddVehicles: {
        ES: 'Añadir vehículos',
        EN: 'Add vehicles',
    },
    PriceReference: {
        ES: 'Precio de referencia',
        EN: 'Price reference',
    },
    ProposedAmount: {
        ES: 'Oferta anterior',
        EN: 'Last offer',
    },
    NewProposedAmount: {
        ES: 'Nuevo importe',
        EN: 'New amount',
    },
    DeleteBatchWarning: {
        ES: batchName =>
            `¿Seguro que quieres eliminar el Lote ${batchName} por completo?`,
        EN: batchName =>
            `Are you sure you want to completely delete Batch ${batchName}?`,
    },
    IrreversibleAction: {
        ES: 'Esta acción es irreversible',
        EN: 'This action is irreversible',
    },
    GoToBatchManagement: {
        ES: 'Ir a gestión de lotes',
        EN: 'Go to batch management',
    },
    BatchTransportReminder: {
        ES: (
            <span>
                Recuerda que una vez hayas conseguido tu lote podrás gestionar
                el <b>transporte</b> de cada vehículo en el apartado de{' '}
                <b>Vehículos comprados</b>.
            </span>
        ),
        EN: (
            <span>
                Remember that once you get your batch, you will be able to
                manage each vehicle <b>transport</b> in <b>Bought vehicles</b>{' '}
                section.
            </span>
        ),
    },
    SuccessProposalModalTitle: {
        ES: (
            <p>
                Hemos recibido correctamente tu propuesta.
                <br />
                Procedemos a realizar una valoración.
            </p>
        ),
        EN: (
            <p>
                We've received your proposal correctly.
                <br />
                We're now gonna deliberate.
            </p>
        ),
    },
    DeleteErrorModalTitle: {
        ES: 'No puedes quedarte con menos de tres vehículos en tu Lote.',
        EN: "You can't have less than 3 vehicles in your Batch.",
    },
    DeleteErrorModalContent: {
        ES:
            'Añade primero un vehículo a tu Lote para poder eliminar el vehículo que desees.',
        EN: "You can't have less than 3 vehicles in your batch.",
    },
    NewBatchName: {
        ES: 'Nuevo nombre del Lote',
        EN: 'New Batch name',
    },
    EditNameTitle: {
        ES: 'Editar nombre',
        EN: 'Edit name',
    },
    Apply: {
        ES: 'Aplicar',
        EN: 'Apply',
    },
    ManagementFiltersStatus: {
        ES: {
            1: 'Activo',
            2: 'Anulado',
            4: 'Comprado',
            5: 'Pendiente',
            7: 'P. Autorización',
        },
        EN: {
            1: 'Active',
            2: 'Cancelled',
            4: 'Bought',
            5: 'Pending',
            7: 'P. Authorization',
        },
    },
    Details: {
        ES: 'Detalles',
        EN: 'Details',
    },
    SendNewProposal: {
        ES: 'Enviar nueva propuesta',
        EN: 'Send new proposal',
    },
    SendProposal: {
        ES: 'Enviar propuesta',
        EN: 'Send proposal',
    },
    UnavailableVehiclesInTrolley: {
        ES: 'Elimina los vehículos no disponibles antes de continuar',
        EN: 'Remove unavailable vehicles before continue',
    },
    NewVehiclesTotal: {
        ES: 'Nuevo total de vehículos',
        EN: 'New total vehicles',
    },
    BatchDatesError: {
        ES:
            'Solo se pueden añadir vehículos con la misma fecha de finalización',
        EN: 'Only vehicles with same end date can be added',
    },
    ClosedBatches: {
        ES: 'Lotes cerrados',
        EN: 'Closed batches',
    },
    SeeClosedBatch: {
        ES: 'Ver lote cerrado',
        EN: 'Watch closed batch',
    },
    SeeAvailable: {
        ES: 'Ver disponibles',
        EN: 'See available',
    },
    BatchDetailsActiveHeaderWarning: {
        ES:
            'Pon un importe a cada vehículo y envía tu propuesta o de lo contrario tu Lote podría ser anulado y perderías la reserva',
        EN:
            'Set an import for all vehicles and send your proposal. Otherwise your Batch could be cancelled and you would lose your reservation',
    },
    BatchDetailsPendingHeaderWarning: {
        ES:
            'Te hemos enviado un correo con los requisitos para mejorar tu propuesta. Revisa tu bandeja de entrada',
        EN:
            "We've sent you an email with the required improvements for your proposal. Check your inbox",
    },
    BatchStatusTip: {
        ES: {
            1: 'El estado Activo significa que has enviado una propuesta. En breve recibirás una respuesta en tu correo',
            5: 'El estado es Pendiente de Mejora significa que has recibido una respuesta en el correo y debes ajustar tu propuesta',
            7: 'Este Lote se encuentra pendiente de autorización, durante este período la propuesta no puede ser modificada',
        },
        EN: {
            1: "Active status means that you have sent a proposal and you'll receive an answer from our department soon",
            5: "Pending status means that you've received in your email an answer from our department and you have to adjust your proposal",
            7: "This Batch is pending of authorization, during this time the proposal can't be modified",
        },
    },
    BatchErrorTitle: {
        ES: '¡Vaya! No se puede añadir este vehículo al Lote',
        EN: "Oops! Vehicle can't be added to Batch",
    },
    MultipleNumberError: {
        ES: number => `El importe debe ser un múltipo de ${number}`,
        EN: number => `Import must be a multiple of ${number}`,
    },
    AddToBatch: {
        ES: 'Añadir al carrito',
        EN: 'Add to cart',
    },
    RemoveFromBatch: {
        ES: 'Quitar del carrito',
        EN: 'Remove from cart',
    },
    StartingPrice: {
        ES: 'Precio de salida',
        EN: 'Starting price',
    },
    DirectPurchasePrice: {
        ES: 'Precio de compra',
        EN: 'Buy price',
    },
    DifferentialAmountTooltip: {
        ES: amount =>
            `Debes superar el valor de Puja Actual por al menos ${amount}€ para poder pujar`,
        EN: amount =>
            `You have to surpass the Actual Bid amount at least by ${amount}€ in order to bid`,
    },
    DirectPurchaseClosedBatchTooltip: {
        ES: amount =>
            `Debes repartir el importe de ${amount}€ entre todos los vehículos para poder comprar el Lote`,
        EN: amount =>
            `You have to distribute the ${amount}€ import between all the vehicles in order to buy the Batch`,
    },
    ClosedBatchAmountWarning: {
        ES: amount =>
            `Debes superar el valor de puja actual con al menos ${amount}€ para poder seguir pujando`,
        EN: amount =>
            `Your bid must be at least ${amount}€ greater than the current bid in order to be able to bid`,
    },
    BuyBatch: {
        ES: 'Comprar Lote',
        EN: 'Buy Batch',
    },
    UpdateAvailable: {
        ES:
            'Hay una nueva versión disponible. Por favor actualiza la aplicación.',
        EN: `There's a new version available. Please update the application.`,
    },
    ClosedBatchSoldContent: {
        ES: 'Pulsa aceptar para volver al listado de subastas',
        EN: 'Press accept to return to the auctions list',
    },
    ClosedBatchSoldTitle: {
        ES: name => `El Lote cerrado ${name} ha sido comprado`,
        EN: name => `Closed batch ${name} has been purchased`,
    },
    ClosedBatchSoldTitleError: {
        ES: name => `Ha ocurrido un error en la compra de el Lote cerrado ${name}`,
        EN: name => `An error occurred when purchasing the closed batch ${name}`,
    },
    ClosedBatchSoldContentError: {
        ES: 'Parece que alguien se te adelantó en la compra del lote. Pulsa aceptar para volver al listado de subastas',
        EN: 'Press accept to return to the auctions list',
    },
    ClosedBatch: {
        ES: 'Lote Cerrado',
        EN: 'Closed Batch',
    },
    InvalidBidFormat: {
        ES:
            'Formato no válido. Las pujas tienen que ser múltiples de 100. Cambia el valor introducido para seguir pujando.',
        EN:
            'Invalid format. Bids must be multiples of 100. Change the bid value to continue.',
    },
    InvalidBidAmount: {
        ES:
            'La puja introducida tiene que ser mayor a la puja actual del vehículo. Por favor, pon una cantidad superior para poder enviarla.',
        EN:
            'Bid amount must be greater than the actual bid. Please set a greater amount in order to continue.',
    },
    InYourBatch: {
        ES: 'en tu Lote',
        EN: 'in your Batch',
    },
    TicketsManagement: {
        ES: 'Gestión de tickets',
        EN: 'Tickets management',
    },
    CreateTicket: {
        ES: 'Alta de ticket',
        EN: 'Create ticket',
    },
    TicketSearch: {
        ES: 'Búsqueda de tickets',
        EN: 'Search tickets',
    },
    TicketManage: {
        ES: 'Gestión de tickets',
        EN: 'Management tickets',
    },
    TicketHistory: {
        ES: 'Tickets en tu historial',
        EN: 'Tickets in your history',
    },
    TicketOrigin: {
        ES: 'Origen del ticket',
        EN: 'Ticket origin',
    },
    TicketTitle: {
        ES: 'Ticket',
        EN: 'Ticket',
    },
    TicketRequestData: {
        ES: 'Datos del solicitante',
        EN: 'Claimant information',
    },
    TicketData: {
        ES: 'Datos del ticket',
        EN: 'Ticket information',
    },
    TicketSearcher: {
        ES: 'Buscador',
        EN: 'Searcher',
    },
    TicketInfoSearcher: {
        ES: 'Matrícula, Nº de Ticket, Op. Financiera',
        EN: 'Plate, Ticket Number, Financial Op.',
    },
    SubmitCreateTicket: {
        ES: 'Dar ticket de alta',
        EN: 'Submit ticket',
    },
    FinalClientPlaceholder: { ES: 'Cliente final', EN: 'Final client' },
    OperationCodePlaceholder: { ES: 'Código operación', EN: 'Operation code' },
    TicketCreationDate: { ES: 'Fecha de alta', EN: 'Creation date' },
    Subject: { ES: 'Asunto', EN: 'Subject' },
    Description: { ES: 'Descripción', EN: 'Description' },
    DescShort: { ES: 'Descripción Corta', EN: 'Short Description' },
    DescLong: { ES: 'Descripción Larga', EN: 'Long Description' },
    ChannelType: { ES: 'Tipo de canal', EN: 'Channel type' },
    ChannelCode: { ES: 'Código de canal', EN: 'Channel code' },
    Concesionario: { ES: 'Concesionario', EN: 'Concessionaire' },
    TicketType: { ES: 'Tipo de ticket', EN: 'Ticket type' },
    TicketNumber: { ES: 'Nº ticket', EN: 'Ticket number' },
    OpFinanciera: { ES: 'Op. Financiera', EN: 'Financial operation' },
    Solictante: { ES: 'Solicitante', EN: 'Applicant' },
    Gestor: { ES: 'Gestor', EN: 'Manager' },
    Resolucion: { ES: 'Resolución', EN: 'Resolution' },
    DateEnd: { ES: 'Fecha finalización', EN: 'End date' },
    SelectOptionPlaceholder: {
        ES: 'Selecciona una opción',
        EN: 'Select an option',
    },
    RequiredFieldError: {
        ES: 'Es necesario rellenar este campo',
        EN: 'This is a required field',
    },
    MaxLengthFieldError: {
        ES: 'Campo supera limite máximo de caracteres',
        EN: 'Field exceeds maximum character limit',
    },
    TicketMade_title: {
        ES: 'Ticket creado correctamente.',
        EN: 'Your ticket has been made successfully.',
    },
    TicketMadeError_title: {
        ES: 'Ha ocurrido un error y no se ha creado el ticket correctamente.',
        EN: 'An error has occurred and the ticket was not created correctly.',
    },
    ErrorViculoPlate: {
        ES: 'La matricula o la Op. Financiera no son correctas',
        EN: "Plate or Operation haven't correct fromat.",
    },
    Others: { ES: 'Otros', EN: 'Others' },
    GroupVW: { ES: 'Grupo VW', EN: 'VW Group' },
    ScrollToTop: { ES: 'Scroll arriba', EN: 'Scroll to top' },
    WithoutTicket_title: {
        ES: 'Lo sentimos, no hemos encontrado ningún ticket',
        EN: 'Sorry, we have not found any ticket',
    },
    TicketInfoSearcherPlaceholder: {
        ES: 'Busca por matrícula, Nº de Ticket, Op. Financiera',
        EN: 'Search by plate, Ticket Number, Financial Op.',
    },
    RegisterFormErrors: {
        ES: {
            required: 'Este campo es obligatorio',
            email: 'Formato de correo no válido',
            phone: 'Formato de teléfono no válido',
            dni: {
                format: 'Formato de DNI no válido',
                matchRequired:
                    'El DNI debe coincidir con el de la solicitud de pre-registro',
            },
            password: {
                capsRequired:
                    'La contraseña debe contener al menos una letra mayúscula',
                numberRequired:
                    'La contraseña debe contener al menos un número',
                matchRequired: 'Las contraseñas no coinciden',
                minLength: amount =>
                    `La contraseña debe tener una longitud mínima de ${amount} carácteres`,
            },
            termsOfService:
                'Debes leer y aceptar los términos y condiciones de uso para continuar',
        },
        EN: {
            required: 'This is a required field',
            email: 'Invalid email format',
            phone: 'Invalid phone format',
            dni: {
                format: 'Invalid DNI format',
                matchRequired: 'DNI must match the pre-registration DNI',
            },
            password: {
                capsRequired:
                    'Password must contain at least one capital letter',
                numberRequired: 'Password must contain at least one number',
                matchRequired: `Passwords doesn't match`,
                minLength: amount =>
                    `Password must be at least ${amount} characters length`,
            },
            termsOfService:
                'You must read and accept terms and service conditions before continue',
        },
    },
    PlaceHolderNewUser: {
        ES: 'Nombre contacto',
        EN: 'Contact name',
    },
    PlaceHolderPhone: {
        ES: 'Teléfono',
        EN: 'Phone',
    },
    PlaceHolderDni: {
        ES: 'NIF / NIE',
        EN: 'NIF / NIE',
    },
    PlaceHolderRegister: {
        ES: 'Nuevo usuario',
        EN: 'New user',
    },
    PlaceHolderEmail: {
        ES: 'Correo',
        EN: 'Email',
    },
    FileSizeError: {
        ES: 'El tamaño del archivo es demasiado grande',
        EN: 'File size is too large',
    },
    FileFormatError: {
        ES: 'La extensión del archivo no es soportada',
        EN: "File extension isn't supported",
    },
    RegisterFormLabel: {
        ES:
            'Ya puedes finalizar tu registro.\n Introduce los siguientes datos:',
        EN: 'You can complete ur registration.\n Complete this information:',
    },
    SubmitRegister: {
        ES: 'Finalizar registro',
        EN: 'Finish register',
    },
    RegisterNotifications: {
        ES: {
            TokenExpired: 'El token de registro ha expirado',
            RegisterSuccess: 'Registro realizado con éxito',
            RegisterFailed: 'Ha habido un error al realizar el registro',
            LoadDataFailed:
                'Ha habido un error al precargar los datos del usuario',
        },
        EN: {
            TokenExpired: 'Register token has expired',
            RegisterSuccess: 'Register successful',
            RegisterFailed: 'Register failed',
            LoadDataFailed: 'Unexpected error preloading user information',
        },
    },
    Number: {
        ES: 'Nº',
        EN: 'Number',
    },
    Offer: { ES: 'Ofertar', EN: 'Offer' },
    OfferAmount: { ES: 'Importe a ofertar', EN: 'Offer amount' },
    CarAccident: {
        ES: 'Histórico de siniestros',
        EN: 'Car accidents',
    },
    RentingPurchaseOption: {
        ES: 'Opción a compra Renting Red / Rac',
        EN: 'Renting red / rac purchase option',
    },
    VehiclesTable: {
        ES: 'Tabla de vehículos',
        EN: 'Vehicles table',
    },
    Brand: { ES: 'Marca', EN: 'Brand' },
    Models: { ES: 'Modelos', EN: 'Models' },
    Model: { ES: 'Modelo', EN: 'Model' },
    Expiration: { ES: 'Vencimiento', EN: 'Expiration' },
    MinImport: { ES: 'Importe mínimo', EN: 'Minimum import' },
    ImportValidityDate: {
        ES: 'F.vigencia importe',
        EN: 'Import validity date',
    },
    ComercialProduct: {
        ES: 'Producto comercial',
        EN: 'Comercial product',
    },
    VehiclesPriceTable: { ES: 'Tabla de Precios', EN: 'Prices Table' },
    ValidityDateFrom: { ES: 'Fecha vigencia desde', EN: 'Date validity from' },
    OwnerChange: { ES: 'Cambio titular', EN: 'Change owner' },
    Assurance: { ES: 'Garantía', EN: 'Assurance' },
    Installations: { ES: 'Concesionarios', EN: 'Installations' },
    SellingImport: { ES: 'Importe de venta', EN: 'Selling price' },
    MinimumSellingImport: {
        ES: 'Importe mínimo de venta',
        EN: 'Minimum selling price',
    },
    FillData: { ES: 'Rellena los siguientes datos:', EN: 'Fill this fields:' },
    PaymentMethod: { ES: 'Método de pago', EN: 'Payment Method' },
    Cash: { ES: 'Contado', EN: 'Cash' },
    VWFSFinancing: { ES: 'Financiación VWFS', EN: 'VWFS Financing' },
    StreetName: { ES: 'Nombre de la vía', EN: 'Street name' },
    Physical: { ES: 'Física', EN: 'Physical' },
    Apartment: { ES: 'Piso', EN: 'Apartment' },
    Select: { ES: 'Seleccionar', EN: 'Select' },
    Business: { ES: 'Razón Social', EN: 'Business' },
    Fiscal: { ES: 'Fiscal', EN: 'Fiscal' },
    CopyDirection: {
        ES: 'Usar los mismos datos que en la Dirección Física',
        EN: 'Use same address than Physical Address',
    },
    ErrorMinimumImport: {
        ES: 'El importe debe ser igual o mayor al mínimo establecido',
        EN: 'Import must be equal or greater than minimum price',
    },
    InvalidFormat: { ES: 'Formato no válido', EN: 'Invalid format' },
    EntryAmount: { ES: 'Importe de entrada', EN: 'Entry import' },
    FinancialAmount: { ES: 'Importe financiado', EN: 'Financial import' },
    ErrorFinancialAmount: {
        ES:
            'La suma de los importes de entrada y financiado debe ser igual al importe de venta',
        EN: 'Financial imports must equal sell amount',
    },
    RentingMinimumImportTooltip: {
        ES: 'Incluye IVA, gastos de Cambio de titular y Garantía (si existe)',
        EN: 'Includes IVA, ownership change fee and warranty (if exists)',
    },
    ExpirationDate: { ES: 'Fecha de vencimiento', EN: 'Expiration date' },
    RentingRedRacPaymentMethods: {
        ES: {
            C: 'Contado',
            F: 'Financiación VWFS',
        },
        EN: {
            C: 'Cash',
            F: 'VWFS Financing',
        },
    },
    YourOffer: {
        ES: 'Tu oferta',
        EN: 'Your offer',
    },
    CheckVehicleStatus: {
        ES: 'Consultar estado de retirada del vehículo',
        EN: 'Check vehicle withdrawal status',
    },
    Search: { ES: 'Buscar', EN: 'Search' },
    PlateFormatError: {
        ES: 'Formato de matrícula inválido',
        EN: 'Invalid plate format',
    },
    CarMaintenance: {
        ES: 'Histórico de mantenimiento',
        EN: 'Car maintenance history',
    },
    Concept: {
        ES: 'Concepto',
        EN: 'Concept',
    },
    LengthError: {
        ES: number => `La longitud máxima es de ${number} carácteres`,
        EN: number => `Cannot exceed ${number} characters`,
    },
    PermissionsErrorTitle: {
        ES: '¡Vaya! Necesitas permisos para acceder',
        EN: 'Ooops!, You need access permissions',
    },
    PermissionsErrorBody: {
        ES:
            'Por favor, ponte en contacto con tu delegado correspondiente para solicitar los permisos de acceso',
        EN:
            'Please, contact your corresponding delegate in order to get your access permissions',
    },
    BillIncludedLabel: {
        ES: included =>
            `El vehículo ${included ? 'incluye' : 'no incluye'} factura`,
        EN: included =>
            `Vehicle ${included ? 'includes' : "doesn't include"} bill`,
    },
    IdentificationDocuments: {
        ES: 'NIF / NIE',
        EN: 'NIF / NIE',
    },
    TraderOnly: {
        ES: 'Solo para compraventas',
        EN: 'Trader only',
    },
    DataSheet: {
        ES: 'Ficha técnica',
        EN: 'Data sheet',
    },
    CarLicence: {
        ES: 'Permiso de circulación',
        EN: 'Car licence',
    },
    Alert: { ES: 'Alerta', EN: 'Alert' },
    DownloadDocumentationError: {
        ES: (document, plate) =>
            `No se ha encontrado ${document == 'FiTec'
                ? 'la Ficha Tecnica'
                : 'el Permiso de circulación'
            } para el vehículo ${plate}`,
        EN: (document, plate) =>
            `Cannot find ${document == 'FiTec' ? 'Technical Sheet' : 'Circulation Permit'
            } for ${plate}`,
    },
    DownloadDocumentationTitleError: {
        ES: 'No se ha encontrado el documento',
        EN: 'Cannot find the document',
    },
    BillDownload: {
        ES: 'Descargar Factura',
        EN: 'Bill Download',
    },
    BillDownloadError: {
        ES: plate => `No se ha encontrado la factura para el vehículo ${plate}`,
        EN: plate => `Cannot find the bill for ${plate}`,
    },
    ProformaDownloadError: {
        ES: plate => `No se ha encontrado la proforma para el vehículo ${plate}`,
        EN: plate => `Cannot find the data for ${plate}`,
    },
    SaleDocumentDownloadError: {
        ES: plate => `No se ha encontrado la el documento para el vehículo ${plate}`,
        EN: plate => `Cannot find the document for ${plate}`,
    },
    ModalSellVWRVehicle_body_1: {
        ES:
            'Selecciona el régimen de venta del vehículo',
        EN:
            'You must choose the vehicle sales regime',
    },
    ModalSellVWRVehicle_body_2: {
        ES:
            'Recuerda que que para que se pueda realizar el proceso de venta a VW Renting se debe enviar la documentación a la gestoría en un plazo máximo de  10 días.',
        EN:
            'Remember that in order for the sale process to VW Renting to be carried out, the documentation must be sent to the agency within a maximum period of 10 days.',
    },
    ModalSellVWRVehicle_incentive_prefix: {
        ES: 'Si continúas con esta opción renuncias al cobro del incentivo de ',
        EN: 'If you continue with this option, you waive the collection of the incentive of ',
    },
    ModalSellVWRVehicle_body_rejected: {
        ES: 'Puedes volver al listado de vehículos.',
        EN: 'You can return to the vehicle list.',
    },

    ModalSellVWRVehicleHelp_body_1: {
        ES:
            'Necesitamos que nos indiquéis el tipo de Régimen Fiscal de la venta para poder emitir la correspondiente factura.',
        EN:
            'We need you to indicate the type of Tax Regime of the sale in order to issue the corresponding invoice.',
    },
    ModalSellVWRVehicleHelp_body_2: {
        ES:
            'En caso de escoger Régimen General, el importe de la venta se calculará desglosando el IVA/IGIC correspondiente.',
        EN:
            'If you choose the General Regime, the amount of the sale will be calculated by breaking down the corresponding VAT/IGIC.',
    },
    ModalSellVWRVehicleHelp_body_3: {
        ES:
            'En caso de escoger Régimen Especial de Bienes Usados (REBU), el importe de la venta se calculará sin desglosar  IVA/IGIC.',
        EN:
            'If you choose the Used Goods Regime (REBU), the amount of the sale will be calculated without breaking down VAT/IGIC.',
    },

    SalesRegime: {
        ES: 'Régimen de venta',
        EN: 'Sales Regime',
    },
    REBU: {
        ES: 'REBU',
        EN: 'REBU',
    },
    REG: {
        ES: 'Regimen General',
        EN: 'General Regime',
    },
    DamagesToReturn: {
        ES: 'Daños a devolver',
        EN: 'Damages to return',
    },
    VehiclesellVWRPrice: {
        ES: 'Total valor venta a VWR',
        EN: 'Vehicle sell price',
    },
    ComisionNotBuy: {
        ES: 'Comision no compra',
        EN: 'Not buy comision',
    },
    AdjudicatedOutstandingBank: {
        ES: 'Adjudicado pdte. cobro Bank',
        EN: 'Outstanding',
    },
    SoldVehiclesVWR: {
        ES: 'Vehículos vendidos VWR',
        EN: 'Sold to VWR vehicles',
    },
    InformationBuyBank: {
        ES: 'Información de compra a Bank',
        EN: 'Information Bank',
    },
    InformationSellVWR: {
        ES: 'Información de venta VWR',
        EN: 'Information VWR',
    },
    SoldVWROutstandng: {
        ES: 'Pdte. de venta VWR',
        EN: 'Outstanding',
    },
    SoldVWRPayed: {
        ES: 'Generada orden de pago por VWR',
        EN: 'Outstanding',
    },
    BuyDateBank: {
        ES: 'Fecha cobro Bank',
        EN: 'Bank Buy date',
    },
    PayDateVWR: {
        ES: 'Fecha orden pago VWR',
        EN: 'VWR Pay date',
    },
    RemovalDate: {
        ES: 'Fecha retirada vehículo',
        EN: 'Vehicle removal date',
    },
    AddRemovalDate: {
        ES: 'Indicar fecha retirada vehículo',
        vEN: 'Add Vehicle removal date',
    },
    RemovalDateSuccess: {
        ES: 'Fecha modificada correctamente',
        EN: 'Date modified successfully',
    },
    InvoiceForDismissalAutocredit: {
        ES: 'Factura de venta',
        EN: 'Sales invoice',
    },
    DismissalWithoutInvoice: {
        ES: 'Pendiente factura cliente.',
        EN:
            'Pending customer invoice.',
    },
    DismissalWithoutInvoice_Full: {
        ES:
            'El cliente de la operación de Autocredit es persona jurídica. A la espera de recibir la factura de venta.',
        EN:
            'The client of the Autocredit operation is a legal entity. Waiting to receive the sales invoice.',
    },
    BuyAutoCredit: {
        ES: 'Adquirir',
        EN: 'Buy',
    },
    SellRenting: {
        ES: 'Venta a VWR',
        EN: 'Sell to VWR',
    },
    PenaltyForDismissalAutocredit: {
        ES: 'Comisión de venta para VWR a deducir del importe',
        EN: 'Sell Comission',
    },
    WithourReport: {
        ES: 'Vehículo no peritado',
        EN:
            'Vehicle not appraised',
    },
    SellVWR: {
        ES: 'Vender a VWR',
        EN: 'Sell to VWR',
    },
    DownloadInvoiceVWR: {
        ES: 'Factura Venta VWR',
        EN: 'VWR Invoice',
    },
    VehicleDelivery: {
        ES: 'Factura Venta VWR',
        EN: 'VWR Invoice',
    },
    DownloadTransferDocuments: {
        ES: 'Descargar Documentación Transferencia',
        EN: 'Download Transfer Documents',
    },
    DownloadDocuments: {
        ES: 'Descargar Documentación',
        EN: 'Download Documents',
    },
    SendDeliveryCertificateByEmail: {
        ES: 'Enviar acta de entrega por email',
        EN: 'Send delivery certificate by Mail',
    },
    SendDeliveryCertificateByEmailOK: {
        ES: 'Acta de entrega enviada a email.',
        EN: 'Delivery certificate send by email',
    },
    SendDeliveryCertificateByEmailError: {
        ES: 'Error en envio de acta por email.',
        EN: 'Error in sending delivery certificate by email',
    },
    DeliveryCertificate: {
        ES: 'Acta de Entrega',
        EN: 'Delivery Certificate',
    },
    TransferDocuments: {
        ES: 'Documentación Transferencia',
        EN: 'Transfer Documents',
    },
};
